import React from 'react';
import PropTypes from 'prop-types';

import FormError from "src/core/gd-form/common/form-error/form-error";
import FormRow from "src/core/gd-form/form/form-ui5/form-row";
import Stepper from "core/gd-form/form-element/stepper/stepper";

export default function CustomFieldDecimalPlaces(props) {
    return (
        <FormRow label="Decimal places">
            <Stepper form={props.form}
                     name="decimalPlaces"
                     minValue={0}
                     maxValue={9}/>
            <FormError form={props.form} name="decimalPlaces" />
        </FormRow>
    );
}

CustomFieldDecimalPlaces.propTypes = {
    form: PropTypes.object
}